import { SectionsTreeNode } from '../types';

export const renameSectionsTreeNodeById = (
  tree: SectionsTreeNode[],
  nodeId: string,
  newName: string,
  newId?: string | null
): SectionsTreeNode[] => {
  const update = (nodes: SectionsTreeNode[]): SectionsTreeNode[] =>
    nodes.map((node) => {
      if (node.id === nodeId) {
        return { ...node, name: newName, ...(!!newId && { id: newId }) };
      }

      if (node.children) {
        const updatedChildren = update(node.children);
        if (updatedChildren !== node.children) {
          return { ...node, children: updatedChildren };
        }
      }

      return node;
    });

  const updatedTree = update(tree);
  return updatedTree;
};
